import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ZuperVerticalNavigationAsideItemComponent } from '@zuper/components/zuper-navigation/vertical/components/aside/aside.component';
import { ZuperVerticalNavigationBasicItemComponent } from '@zuper/components/zuper-navigation/vertical/components/basic/basic.component';
import { ZuperVerticalNavigationCollapsableItemComponent } from '@zuper/components/zuper-navigation/vertical/components/collapsable/collapsable.component';
import { ZuperVerticalNavigationDividerItemComponent } from '@zuper/components/zuper-navigation/vertical/components/divider/divider.component';
import { ZuperVerticalNavigationGroupItemComponent } from '@zuper/components/zuper-navigation/vertical/components/group/group.component';
import { ZuperVerticalNavigationSpacerItemComponent } from '@zuper/components/zuper-navigation/vertical/components/spacer/spacer.component';
import { ZuperVerticalNavigationComponent } from './vertical/vertical.component';
import { ZuperScrollbarModule } from '@zuper/directives/scrollbar/scrollbar.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        ZuperVerticalNavigationAsideItemComponent,
        ZuperVerticalNavigationBasicItemComponent,
        ZuperVerticalNavigationCollapsableItemComponent,
        ZuperVerticalNavigationDividerItemComponent,
        ZuperVerticalNavigationGroupItemComponent,
        ZuperVerticalNavigationSpacerItemComponent,
        ZuperVerticalNavigationComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        ZuperScrollbarModule,
        TranslateModule
    ],
    exports     : [
        ZuperVerticalNavigationComponent
    ]
})
export class ZuperNavigationModule
{
}
